import React, { useContext } from "react";
import { Modal, ModalBody, Spinner, Col } from "reactstrap";
import { PROFILE } from "../constants/RoutesUrl";
import ImageComponent from "../components/common/ImageComponent.jsx";
import Avatar from "../assets/images/icon/placeholder_Awatar.png";
import InfiniteScroll from "react-infinite-scroller";
import { Link, useNavigate } from "react-router-dom";
import { Language } from "../App";
import { _imagesURL } from "../constants/API.js";
import { IoCloseSharp } from "react-icons/io5";
import { IoThumbsUp } from "react-icons/io5";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { FiChevronRight } from "react-icons/fi";
import "../components/modals/reactedUsersModal.css";

const LikeUsersModal = ({
  isOpen,
  toggleLikesModal,
  likeSpinner,
  likeUsers = {},
  handleNewLikeUsers,
}) => {
  const { lang } = useContext(Language);
  const navigate = useNavigate();

  const userList = Array.isArray(likeUsers)
    ? likeUsers
    : likeUsers?.data || [];

  const totalCount =
    likeUsers?.total || userList.length || 0;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleLikesModal}
      centered
      zIndex={1060}
      className="rum-modal-dialog"
    >
      {/* Sleek Header */}
      <div className="rum-header">
        <div className="rum-header-left">
          <div className="rum-icon-pill">
            <IoThumbsUp size={16} />
          </div>
          <div>
            <h5 className="rum-title">
              {lang?.reacted_users || lang?.liked_users || "Reacted Users"}
            </h5>
          </div>
          {totalCount > 0 && (
            <span className="rum-count-pill">
              {totalCount}
            </span>
          )}
        </div>
        <button
          type="button"
          className="rum-close-btn"
          onClick={toggleLikesModal}
          aria-label="Close"
        >
          <IoCloseSharp size={18} />
        </button>
      </div>

      <ModalBody className="rum-body p-0">
        {likeSpinner ? (
          <Col className="my-5 text-center">
            <Spinner color="info" />
          </Col>
        ) : userList.length === 0 ? (
          <div className="rum-empty-state">
            <div className="rum-empty-icon">
              <IoThumbsUp size={22} />
            </div>
            <p className="mb-0 fw-medium">No reactions yet</p>
          </div>
        ) : (
          <div className="p-3">
            <InfiniteScroll
              pageStart={0}
              loadMore={handleNewLikeUsers}
              hasMore={
                likeUsers?.current_page &&
                likeUsers?.last_page &&
                likeUsers?.current_page < likeUsers?.last_page
              }
              loader={
                <Col className="text-center my-3" key="loader">
                  <Spinner size="sm" color="info" />
                </Col>
              }
              useWindow={false}
            >
              {userList.map((value, index) => (
                <Link
                  key={value.id || index}
                  onClick={(e) => {
                    e.preventDefault();
                    if (toggleLikesModal) toggleLikesModal();
                    navigate(PROFILE + "/" + value.id);
                  }}
                  className="rum-user-card"
                >
                  <div className="d-flex align-items-center flex-grow-1 min-w-0">
                    <div className="rum-avatar-wrapper">
                      <ImageComponent
                        src={
                          value?.image ? _imagesURL + value.image : Avatar
                        }
                        compClassName="rum-avatar-img"
                        img_height="46px"
                        img_width="46px"
                        loader_height="46px"
                        loader_width="46px"
                      />
                      <div className="rum-reaction-badge">
                        <IoThumbsUp size={9} />
                      </div>
                    </div>

                    <div className="rum-user-info">
                      <h6 className="rum-user-name">
                        <span>{value.name}</span>
                        {value.role === "doctor" || value.is_verified ? (
                          <RiVerifiedBadgeFill
                            size={15}
                            className="rum-verified-icon"
                          />
                        ) : null}
                      </h6>
                      <p className="rum-username">
                        @{value.user_name || value.username || "doctor"}
                      </p>
                    </div>
                  </div>

                  <FiChevronRight size={18} className="rum-chevron" />
                </Link>
              ))}
            </InfiniteScroll>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
};

export default LikeUsersModal;
export { LikeUsersModal as ReactedUsersModal };
